import React, { Component } from 'react';

import Cardlist from '../Components/cardlist';
import Searchbox from '../Components/searchbox';
import Scroll from '../Components/scroll';
import './App.css';
import ErrorBoundary from '../Components/ErrorBoundary';




class App extends Component{
    constructor(){
        super()
        this.state = {
                        // robots: robots,
                        robots: [],
                        searchfield : ""
                    }
    }
    componentDidMount(){
        fetch('https://jsonplaceholder.typicode.com/users')
        .then(Response => Response.json())
            .then(users => this.setState({robots: users}))
 
     }


    onsearchchange=(event) =>{
        // console.log(event.target.value);
        this.setState({searchfield : event.target.value})   
    }   
    render() {
        const {robots,searchfield} = this.state;
        const filterRobots = robots.filter(robot =>{
        return robot.name.toLowerCase().includes(searchfield.toLowerCase())
           
        })       
        if(!robots.length){
            return <h1>Loading....</h1>
        } else {
            return (
                    <div className='tc'>
                        <h2 className='f2'>Robofriends</h2>
                        <Searchbox searchchange={this.onsearchchange}/>
                         <Scroll>
                        <ErrorBoundary>
                        <Cardlist robots={filterRobots}/>
                        </ErrorBoundary>
                    
                        </Scroll>
                    
                    </div>
                   )
              }
        
    }
}
export default App

//  console.log(filterRobots)

/* // <Cardlist robots={this.state.robots}/> */










// const App = ()=>{
//     return(
//         <div className='tc'>
//         <h2>Robofriends</h2>
//         <Searchbox />
//         <Cardlist robots={robots}/>
//         </div>
//     )
// }
// export default App;